import { createContext } from 'react';
export var GuardContext = createContext(undefined);

//# sourceMappingURL=GuardContext.js.map